export class GoogleAnalyticsTrackingService {

    constructor(Analytics, cartService, GA_TRACKING_LABEL, GTM_TRACKING_TAGS, featureFlagService, $filter, $window) {
        'ngInject';

        this.cartService = cartService;
        this.featureFlagService = featureFlagService;
        this.$filter = $filter;
        this.$window = $window;

        this.Analytics = Analytics;

        this.GA_TRACKING_LABEL = GA_TRACKING_LABEL;

        this.CATEGORY_CART_EDIT = GA_TRACKING_LABEL.EVENT_CATEGORY.CART_EDIT;
        this.ACTION_ADD_ITEM = this.CATEGORY_CART_EDIT.EVENT_ACTION.ADD_ITEM;
        this.ACTION_START_EDIT_DETAIL = this.CATEGORY_CART_EDIT.EVENT_ACTION.START_EDIT_DETAILS;

        this.CATEGORY_PROFILE = GA_TRACKING_LABEL.EVENT_CATEGORY.PROFILE;
        this.ACTION_ADDRESS = this.CATEGORY_PROFILE.EVENT_ACTION.ADDRESS;
        this.ACTION_UPDATE_PASSWORD = this.CATEGORY_PROFILE.EVENT_ACTION.UPDATE_PASSWORD;
        this.ACTION_BASIC_INFO = this.CATEGORY_PROFILE.EVENT_ACTION.BASIC_INFO;

        this.CATEGORY_CHECKOUT = GA_TRACKING_LABEL.EVENT_CATEGORY.CHECKOUT;
        this.ACTION_PLACE_ORDER = this.CATEGORY_CHECKOUT.EVENT_ACTION.PLACE_ORDER;

        this.CATEGORY_ACCOUNT_CREATION = GA_TRACKING_LABEL.EVENT_CATEGORY.ACCOUNT_CREATION;

        this.CATEGORY_PROMO_CODE = GA_TRACKING_LABEL.EVENT_CATEGORY.PROMO_CODE;
        this.ACTION_APPLY_PROMO_CODE = this.CATEGORY_PROMO_CODE.EVENT_ACTION.APPLY;
        this.ACTION_REMOVE_PROMO_CODE = this.CATEGORY_PROMO_CODE.EVENT_ACTION.REMOVE;

        this.CATEGORY_NAVIGATION = GA_TRACKING_LABEL.EVENT_CATEGORY.NAVIGATION;
        this.ACTION_SOCIAL_MEDIA = this.CATEGORY_NAVIGATION.EVENT_ACTION.SOCIAL_MEDIA;

        this.CATEGORY_LOGIN = GA_TRACKING_LABEL.EVENT_CATEGORY.LOGIN;
        this.CATEGORY_FORGOT_PASSWORD = GA_TRACKING_LABEL.EVENT_CATEGORY.FORGOT_PASSWORD;
        this.CATEGORY_ACCOUNT_CREATION = GA_TRACKING_LABEL.EVENT_CATEGORY.ACCOUNT_CREATION;

        this.CATEGORY_LANDING_PAGE = GA_TRACKING_LABEL.EVENT_CATEGORY.LANDING_PAGE;
        this.ACTION_VERIFY_ADDRESS = this.CATEGORY_LANDING_PAGE.EVENT_ACTION.VERIFY_ADDRESS;

        this.CATEGORY_MENU_SELECTION = GA_TRACKING_LABEL.EVENT_CATEGORY.MENU_SELECTION;
        this.ACTION_MENU_ITEM_QUANTITY = this.CATEGORY_MENU_SELECTION.EVENT_ACTION.MENU_ITEM_QUANTITY;
        this.ACTION_MODIFIER_SELECTION = this.CATEGORY_MENU_SELECTION.EVENT_ACTION.MODIFIER_SELECTION;

        this.GTM_TRACKING_TAGS = GTM_TRACKING_TAGS;

        this.CATEGORY_LOYALTY_REWARDS = GA_TRACKING_LABEL.EVENT_CATEGORY.LOYALTY_REWARDS;
        this.ACTION_LOOKUP_LOYALTY_REDEMPTION = this.CATEGORY_LOYALTY_REWARDS.EVENT_ACTION.LOOKUP_REWARDS;
        this.ACTION_APPLY_LOYALTY_REDEMPTION = this.CATEGORY_LOYALTY_REWARDS.EVENT_ACTION.APPLY_REWARD;
        this.ACTION_UNDO_LOYALTY_REDEMPTION = this.CATEGORY_LOYALTY_REWARDS.EVENT_ACTION.UNDO_REWARD;
        this.ACTION_REMOVE_LOYALTY_REDEMPTION = this.CATEGORY_LOYALTY_REWARDS.EVENT_ACTION.REMOVE_REWARD;
    }

    getReorderEvent() {
        return [
            this.CATEGORY_CART_EDIT.TEXT,
            this.ACTION_ADD_ITEM.TEXT,
            this.ACTION_ADD_ITEM.EVENT_LABEL.REORDER.TEXT
        ];
    }

    getAddAddressEvent() {
        return [
            this.CATEGORY_PROFILE.TEXT,
            this.ACTION_ADDRESS.TEXT,
            this.ACTION_ADDRESS.EVENT_LABEL.ADD.TEXT
        ];
    }

    getStandardTipEvent(tip) {
        return [
            this.CATEGORY_CHECKOUT.TEXT,
            this.CATEGORY_CHECKOUT.EVENT_ACTION.ADDED_TIP.TEXT,
            this.$filter('number')(tip.percent * 100, 0) + '%'
        ];
    }

    getBackToMenuEvent() {
        return [
            this.CATEGORY_CHECKOUT.TEXT,
            this.CATEGORY_CHECKOUT.EVENT_ACTION.BACK_TO_MENU.TEXT
        ];
    }

    getBuyGCEvent() {
        return [
            this.CATEGORY_NAVIGATION.TEXT,
            this.CATEGORY_NAVIGATION.EVENT_ACTION.BUY_GC.TEXT
        ];
    }

    getCheckAddGCEvent() {
        return [
            this.CATEGORY_NAVIGATION.TEXT,
            this.CATEGORY_NAVIGATION.EVENT_ACTION.GC_CHECK_ADD.TEXT
        ];
    }

    getFacebookLinkClickEvent() {
        return [
            this.CATEGORY_NAVIGATION.TEXT,
            this.ACTION_SOCIAL_MEDIA.TEXT,
            this.ACTION_SOCIAL_MEDIA.EVENT_LABEL.FACEBOOK.TEXT
        ];
    }

    getTwitterLinkClickEvent() {
        return [
            this.CATEGORY_NAVIGATION.TEXT,
            this.ACTION_SOCIAL_MEDIA.TEXT,
            this.ACTION_SOCIAL_MEDIA.EVENT_LABEL.TWITTER.TEXT
        ];
    }

    getMenuEvent() {
        return [
            this.CATEGORY_NAVIGATION.TEXT,
            this.CATEGORY_NAVIGATION.EVENT_ACTION.MENU.TEXT
        ];
    }

    getOpenMenuEvent() {
        return [
            this.CATEGORY_LOGIN.TEXT,
            this.CATEGORY_LOGIN.EVENT_ACTION.LOGIN_MODAL.TEXT
        ];
    }

    getMenuGroupSelectionEvent() {
        return [
            this.CATEGORY_MENU_SELECTION.TEXT,
            this.CATEGORY_MENU_SELECTION.EVENT_ACTION.MENU_GROUP.TEXT
        ];
    }

    getMenuItemSelectionEvent() {
        return [
            this.CATEGORY_MENU_SELECTION.TEXT,
            this.CATEGORY_MENU_SELECTION.EVENT_ACTION.MENU_ITEM.TEXT
        ];
    }

    getModifierGroupSelectionEvent() {
        return [
            this.CATEGORY_MENU_SELECTION.TEXT,
            this.CATEGORY_MENU_SELECTION.EVENT_ACTION.MODIFIER_GROUP.TEXT
        ];
    }

    getIncrementQuantityEvent() {
        return [
            this.CATEGORY_MENU_SELECTION.TEXT,
            this.ACTION_MENU_ITEM_QUANTITY.TEXT,
            this.ACTION_MENU_ITEM_QUANTITY.EVENT_LABEL.INCREMENT.TEXT
        ];
    }

    getDecrementQuantityEvent() {
        return [
            this.CATEGORY_MENU_SELECTION.TEXT,
            this.ACTION_MENU_ITEM_QUANTITY.TEXT,
            this.ACTION_MENU_ITEM_QUANTITY.EVENT_LABEL.DECREMENT.TEXT
        ];
    }

    getRemoveItemEvent() {
        return [
            this.CATEGORY_CART_EDIT.TEXT,
            this.CATEGORY_CART_EDIT.EVENT_ACTION.REMOVE_ITEM.TEXT
        ];
    }

    getStartUpdateItemEvent() {
        return [
            this.CATEGORY_CART_EDIT.TEXT,
            this.CATEGORY_CART_EDIT.EVENT_ACTION.START_UPDATE_ITEM.TEXT
        ];
    }

    getStartEditDetailsOnDiningOptionPreviewEvent() {
        return [
            this.CATEGORY_CART_EDIT.TEXT,
            this.ACTION_START_EDIT_DETAIL.TEXT,
            this.ACTION_START_EDIT_DETAIL.EVENT_LABEL.DINING_OPTION_PREVIEW.TEXT
        ];
    }

    getStartEditDetailsOnDateTimePreviewEvent() {
        return [
            this.CATEGORY_CART_EDIT.TEXT,
            this.ACTION_START_EDIT_DETAIL.TEXT,
            this.ACTION_START_EDIT_DETAIL.EVENT_LABEL.DATE_TIME_PREVIEW.TEXT
        ];
    }

    getStartEditDetailsOnEditDetailButtonEvent() {
        return [
            this.CATEGORY_CART_EDIT.TEXT,
            this.ACTION_START_EDIT_DETAIL.TEXT,
            this.ACTION_START_EDIT_DETAIL.EVENT_LABEL.EDIT_DETAIL_BUTTON.TEXT
        ];
    }

    trackAddress(label) {
        let labelText;
        if (label === 'success') {
            labelText = this.ACTION_ADDRESS.EVENT_LABEL.SUCCESS.TEXT;
        } else if (label === 'error') {
            labelText = this.ACTION_ADDRESS.EVENT_LABEL.ERROR.TEXT;
        } else {
            labelText = this.ACTION_ADDRESS.EVENT_LABEL.DELETE.TEXT;
        }

        this.Analytics.trackEvent(
            this.CATEGORY_PROFILE.TEXT,
            this.ACTION_ADDRESS.TEXT,
            labelText
        );
    }

    trackUpdatePassword(label) {
        let labelText;
        if (label === 'success') {
            labelText = this.ACTION_UPDATE_PASSWORD.EVENT_LABEL.SUCCESS.TEXT;
        } else if (label === 'error') {
            labelText = this.ACTION_UPDATE_PASSWORD.EVENT_LABEL.ERROR.TEXT;
        } else {
            labelText = this.ACTION_UPDATE_PASSWORD.EVENT_LABEL.CANCEL.TEXT;
        }

        this.Analytics.trackEvent(
            this.CATEGORY_PROFILE.TEXT,
            this.ACTION_UPDATE_PASSWORD.TEXT,
            labelText
        );
    }

    trackAfterPlaceOrderErrorOccurred() {
        const category = this.GA_TRACKING_LABEL.EVENT_CATEGORY.AFTER_PLACE_ORDER_ERROR;

        this.Analytics.trackEvent(
            category.TEXT,
            category.EVENT_ACTION.OCCURRED.TEXT
        );
    }

    trackAfterPlaceOrderErrorRetry() {
        const category = this.GA_TRACKING_LABEL.EVENT_CATEGORY.AFTER_PLACE_ORDER_ERROR;

        this.Analytics.trackEvent(
            category.TEXT,
            category.EVENT_ACTION.RETRY.TEXT
        );
    }

    trackAfterPlaceOrderErrorCancel() {
        const category = this.GA_TRACKING_LABEL.EVENT_CATEGORY.AFTER_PLACE_ORDER_ERROR;

        this.Analytics.trackEvent(
            category.TEXT,
            category.EVENT_ACTION.CANCEL.TEXT
        );
    }

    trackSelectAddressSuggestion() {
        this.Analytics.trackEvent(
            this.CATEGORY_CHECKOUT.TEXT,
            this.CATEGORY_CHECKOUT.EVENT_ACTION.ADDRESS_SUGGESTION.TEXT
        );
    }

    trackBasicInfo(isSubmit) {
        this.Analytics.trackEvent(
            this.CATEGORY_PROFILE.TEXT,
            this.ACTION_BASIC_INFO.TEXT,
            isSubmit ? this.ACTION_BASIC_INFO.EVENT_LABEL.SAVE.TEXT : this.ACTION_BASIC_INFO.EVENT_LABEL.CANCEL.TEXT
        );
    }

    trackCreateAccountSuccess() {
        this.Analytics.trackEvent(
            this.CATEGORY_ACCOUNT_CREATION.TEXT,
            this.CATEGORY_ACCOUNT_CREATION.EVENT_ACTION.CREATE_ACCOUNT_SUCCESSFUL.TEXT
        );
    }

    trackCreateAccountError(errorMessage) {
        this.Analytics.trackEvent(
            this.CATEGORY_ACCOUNT_CREATION.TEXT,
            this.CATEGORY_ACCOUNT_CREATION.EVENT_ACTION.CREATE_ACCOUNT_ERROR.TEXT,
            errorMessage
        );
    }

    trackTermsOfService() {
        this.Analytics.trackEvent(
            this.CATEGORY_ACCOUNT_CREATION.TEXT,
            this.CATEGORY_ACCOUNT_CREATION.EVENT_ACTION.TERMS.TEXT
        );
    }

    trackPrivacyPolicy() {
        this.Analytics.trackEvent(
            this.CATEGORY_ACCOUNT_CREATION.TEXT,
            this.CATEGORY_ACCOUNT_CREATION.EVENT_ACTION.PRIVACY.TEXT
        );
    }

    trackPlaceOrder({ isSuccess, hasLoyaltyRedemption, loyaltyRedemptionAmount } = {}) {

        this.Analytics.trackEvent(
            this.CATEGORY_CHECKOUT.TEXT,
            this.ACTION_PLACE_ORDER.TEXT,
            isSuccess ? this.ACTION_PLACE_ORDER.EVENT_LABEL.SUCCESS.TEXT : this.ACTION_PLACE_ORDER.EVENT_LABEL.ERROR.TEXT,
            {
                dimension9: hasLoyaltyRedemption.toString(),
                metric2: loyaltyRedemptionAmount
            }
        );

        this._trackGoogleTagManagerEvent(this.GTM_TRACKING_TAGS.PLACE_ORDER);
    }

    trackPromoCode(actionText, isSuccess, promoCode) {
        let action;
        if (actionText === 'apply') {
            action = this.ACTION_APPLY_PROMO_CODE;
        } else {
            action = this.ACTION_REMOVE_PROMO_CODE;
        }

        this.Analytics.trackEvent(
            this.CATEGORY_PROMO_CODE.TEXT,
            action.TEXT,
            isSuccess ? action.EVENT_LABEL.SUCCESS.TEXT : action.EVENT_LABEL.ERROR.TEXT,
            {
                metric1: promoCode
            }
        );
    }

    // @deprecated by NM to reduce GA tracking events
    trackCanPlaceOrderEvent(canPlaceOrder) {
        if (canPlaceOrder) {
            this.Analytics.trackEvent(
                this.CATEGORY_CHECKOUT.TEXT,
                this.CATEGORY_CHECKOUT.EVENT_ACTION.CHECKOUT_VALID.TEXT
            );
        }
    }

    trackCheckoutAtMenuEvent(cartData) {
        this.Analytics.trackEvent(
            this.CATEGORY_CHECKOUT.TEXT,
            this.CATEGORY_CHECKOUT.EVENT_ACTION.CHECKOUT_CLICK.TEXT
        );

        this._trackGoogleTagManagerEvent(this.GTM_TRACKING_TAGS.CHECKOUT);

        this._trackECCheckout(cartData, 1);
    }

    trackLoginSuccess() {
        this.Analytics.trackEvent(
            this.CATEGORY_LOGIN.TEXT,
            this.CATEGORY_LOGIN.EVENT_ACTION.LOGIN_SUCCESSFUL.TEXT
        );
    }

    trackLoginError(errorMessage) {
        this.Analytics.trackEvent(
            this.CATEGORY_LOGIN.TEXT,
            this.CATEGORY_LOGIN.EVENT_ACTION.LOGIN_ERROR.TEXT,
            errorMessage
        );
    }

    trackForgotPassword() {
        this.Analytics.trackEvent(
            this.CATEGORY_FORGOT_PASSWORD.TEXT,
            this.CATEGORY_FORGOT_PASSWORD.EVENT_ACTION.FORGOT_PASSWORD.TEXT
        );
    }

    trackSendInstructions() {
        this.Analytics.trackEvent(
            this.CATEGORY_FORGOT_PASSWORD.TEXT,
            this.CATEGORY_FORGOT_PASSWORD.EVENT_ACTION.SEND_INSTRUCTIONS.TEXT
        );
    }

    trackGoEvent(diningOption) {
        this.Analytics.trackEvent(
            this.CATEGORY_LANDING_PAGE.TEXT,
            this.CATEGORY_LANDING_PAGE.EVENT_ACTION.GO.TEXT
        );

        this.Analytics.trackEvent(
            this.CATEGORY_LANDING_PAGE.TEXT,
            this.CATEGORY_LANDING_PAGE.EVENT_ACTION.DINING_OPTION.TEXT,
            diningOption
        );

        this._trackGoogleTagManagerEvent(this.GTM_TRACKING_TAGS.VIEW_MENU);
    }

    trackVerifyAddress(errorMessage) {
        this.Analytics.trackEvent(
            this.CATEGORY_LANDING_PAGE.TEXT,
            this.ACTION_VERIFY_ADDRESS.TEXT,
            errorMessage ? this.ACTION_VERIFY_ADDRESS.EVENT_LABEL.ERROR.TEXT : this.ACTION_VERIFY_ADDRESS.EVENT_LABEL.SUCCESS.TEXT,
            errorMessage ? { error: errorMessage } : undefined
        );
    }

    trackAddOrUpdateItemEvent(item) {
        if (item.hasOwnProperty('uniqueIdString')) {
            this.Analytics.trackEvent(
                this.CATEGORY_CART_EDIT.TEXT,
                this.CATEGORY_CART_EDIT.EVENT_ACTION.FINISH_UPDATE_ITEM.TEXT
            );
        } else {
            this.Analytics.trackEvent(
                this.CATEGORY_CART_EDIT.TEXT,
                this.ACTION_ADD_ITEM.TEXT,
                this.ACTION_ADD_ITEM.EVENT_LABEL.ADD_ITEM.TEXT
            );

            this._trackECAddCartItem(item);
        }
    }

    trackModifierSelection(isSelected) {
        this.Analytics.trackEvent(
            this.CATEGORY_MENU_SELECTION.TEXT,
            this.ACTION_MODIFIER_SELECTION.TEXT,
            isSelected ? this.ACTION_MODIFIER_SELECTION.EVENT_LABEL.SELECT.TEXT : this.ACTION_MODIFIER_SELECTION.EVENT_LABEL.DESELECT.TEXT
        );
    }

    trackDateTimeChange() {
        this.Analytics.trackEvent(
            this.CATEGORY_LANDING_PAGE.TEXT,
            this.CATEGORY_LANDING_PAGE.EVENT_ACTION.DATE_TIME.TEXT
        );
    }

    trackFinishEditDetailsEvent() {
        this.Analytics.trackEvent(
            this.CATEGORY_CART_EDIT.TEXT,
            this.CATEGORY_CART_EDIT.EVENT_ACTION.FINISH_EDIT_DETAILS.TEXT
        );
    }

    trackECProductDetail(detail) {
        let price = this._formatGACurrency(detail);

        this.Analytics.addProduct(
            detail.idString,
            detail.name,
            undefined, undefined, undefined,
            price,
            1,
            undefined, undefined
        );
        this.Analytics.trackDetail();
    }

    /**
     * The item detail passed into this method can either have a single price field, or an array of prices (size priced).
     * We either return the float representing the single price field, or the float representing the lower bound of the size price range.
     */
    _formatGACurrency(detail) {
        let priceString = this.$filter('pricePreview')(detail)
            .replace(/^\$(.+?)(?:\u2014.*)?$/, '$1');
        return parseFloat(priceString).toFixed(2);
    }

    _trackECAddCartItem(item) {
        this.Analytics.addProduct(
            item.idString,
            item.name,
            undefined, undefined, undefined,
            item.price,
            item.quantity,
            undefined, undefined
        );
        this.Analytics.trackCart('add');
    }

    trackECRemoveCartItem(item) {
        this.Analytics.addProduct(
            item.idString,
            item.name,
            undefined, undefined, undefined,
            item.price,
            item.quantity,
            undefined, undefined
        );
        this.Analytics.trackCart('remove');
    }

    _trackECCheckout(cartData, step, options) {
        cartData.cart.items.forEach(item => {
            this.Analytics.addProduct(
                item.idString,
                item.name,
                undefined, undefined, undefined,
                item.price,
                item.quantity,
                undefined, undefined
            );
        });
        this.Analytics.trackCheckout(step, options);
        this.Analytics.pageView();
    }

    _trackGoogleTagManagerEvent(googleTagManagerTag) {
        if (this.featureFlagService.flagEnabled('oo-3rd-party-analytics') && this.$window.dataLayer) {

            var tag = { event: googleTagManagerTag };

            if (googleTagManagerTag === this.GTM_TRACKING_TAGS.PLACE_ORDER) {
                tag.ooOrderValue = this.cartService.data.cart.check.totalAmount;
            }

            this.$window.dataLayer.push(tag);
        }
    }

    trackLoyaltyRedemptionVisible() {
        this.Analytics.trackEvent(
            this.CATEGORY_LOYALTY_REWARDS.TEXT,
            this.CATEGORY_LOYALTY_REWARDS.EVENT_ACTION.REWARDS_AVAILABLE.TEXT
        );
    }

    trackLoyaltyRedemption(actionText, isSuccess) {
        let action;
        switch (actionText) {
        case 'lookup':
            action = this.ACTION_LOOKUP_LOYALTY_REDEMPTION;
            break;
        case 'apply':
            action = this.ACTION_APPLY_LOYALTY_REDEMPTION;
            break;
        case 'undo':
            action = this.ACTION_UNDO_LOYALTY_REDEMPTION;
            break;
        case 'remove':
            action = this.ACTION_REMOVE_LOYALTY_REDEMPTION;
            break;
        default:
            return;
        }

        this.Analytics.trackEvent(
            this.CATEGORY_LOYALTY_REWARDS.TEXT,
            action.TEXT,
            isSuccess ? action.EVENT_LABEL.SUCCESS.TEXT : action.EVENT_LABEL.ERROR.TEXT
        );
    }
}
